// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"686":"8fad5e7b","816":"bb8da9ce"}[chunkId] + ".css";
};